<script>
  export let articulo;
  export let onClickArticle;

  import { getId } from "../utils/getId";

  import { onMount } from "svelte";

  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let enviadoColor = "";
  let estado = "";

  onMount(() => {
    switch (articulo.estado) {
      case "Enviado":
        enviadoColor = "var(--revista-blue)";
        estado = dict["1revision"];
        break;
      case "Revision":
        enviadoColor = "var(--revista-blue)";
        estado = dict["1revision"];
        break;
      case "Revision 2":
        enviadoColor = "var(--revista-blue)";
        estado = dict["2revision"];
        break;
      case "Aceptado":
        enviadoColor = "var(--revista-green)";
        estado = dict["finalizado"];
        break;
      case "Rechazado":
        enviadoColor = "var(--revista-green)";
        estado = dict["finalizado"];
        break;
    }
  });
</script>

<style>
  table.articleList {
    width: 100%;
    color: var(--revista-black);
    border-color: lightgray;
    border-style: solid;
    border-width: 1px;
    margin-top: 40px;
  }

  table.articleList td {
    padding: 10px;
  }

  .borderBottom {
    border-bottom-color: lightgray;
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  td.title {
    font-weight: bold;
    font-size: 18px;
    position: relative;
  }

  div.titleDiv {
    cursor: pointer;
  }

  img.arrow {
    margin-left: 5px;
    height: 15px;
    width: 15px;
  }

  td.icons img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
  }

  span.titleEN {
    font-weight: normal;
    font-size: 14px;
  }

  span.id {
    font-weight: normal;
    font-size: 12px;
  }
</style>

<table class="articleList">
  <tr class="borderBottom">
    <td class="title">
      <div
        class={articulo.miDecision !== 'No' || articulo.revisadoDocumento1 !== '' ? 'titleDiv' : ''}
        on:click={articulo.miDecision !== 'No' || articulo.revisadoDocumento1 !== '' ? onClickArticle : null}>
        <span class="id">
          {getId(articulo.fechaSolicitud, articulo.id_articulo)}
        </span>
        <div>
          {articulo.titulo}
          {#if articulo.miDecision !== 'No' || articulo.revisadoDocumento1 !== ''}
            <img
              class="arrow"
              src="/images/revista/right-arrow.svg"
              alt="Arrow" />
          {/if}
        </div>
        <span class="titleEN">{articulo.tituloEN}</span>
      </div>
    </td>
  </tr>
  <tr class="borderBottom">
    <td>
      {#each articulo.firmas as autor, i}
        <span>{autor}{i < articulo.firmas.length - 1 ? ' · ' : ''}</span>
      {/each}
    </td>
  </tr>
  <tr class="borderBottom">
    <td>
      <b>{dict['estado']}:</b>
      <span style="color: {enviadoColor}">{estado}</span>
    </td>
  </tr>
  <tr class="borderBottom">
    <td class="icons">
      <b>{dict['aceptadaRevision']}:</b>
      {#if articulo.miDecision === 'Si'}
        <img
          src="/images/revista/revisor-accept.svg"
          title={dict['decisionRevisorOk']}
          alt="Revisor Icon" />
      {:else if articulo.miDecision === 'No'}
        <img
          src="/images/revista/revisor-reject.svg"
          title={dict['decisionRevisorNoOk']}
          alt="Revisor Icon" />
      {:else}
        <img
          src="/images/revista/clock.svg"
          title={dict['decisionRevisor']}
          alt="Revisor Icon" />
      {/if}
    </td>
  </tr>
  <tr class="borderBottom">
    <td class="icons">
      <b>{dict['revision']} v1:</b>
      {#if articulo.revisadoDocumento1 === 'Aceptado'}
        <img
          src="/images/revista/revisor-v-color.svg"
          title={dict['aceptadoParaPublicacion']}
          alt="Revision Icon" />
      {:else if articulo.revisadoDocumento1 === 'CambiosMenores'}
        <img
          src="/images/revista/revisor-v-minor-color.svg"
          title={dict['aceptadoConCambiosMenores']}
          alt="Revision Icon" />
      {:else if articulo.revisadoDocumento1 === 'CambiosMayores'}
        <img
          src="/images/revista/revisor-v-major-color.svg"
          title={dict['aceptadoConCambiosMayores']}
          alt="Revision Icon" />
      {:else if articulo.revisadoDocumento1 === 'Rechazado'}
        <img
          src="/images/revista/revisor-x-color.svg"
          title={dict['rechazado']}
          alt="Revision Icon" />
      {:else}
        <img
          src="/images/revista/clock.svg"
          title={dict['esperandoRevision']}
          alt="Revision Icon" />
      {/if}
    </td>
  </tr>
  {#if articulo.numVersion === 2}
    <tr class="borderBottom">
      <td class="icons">
        <b>{dict['revision']} v2:</b>
        {#if articulo.revisadoDocumento2 === 'Aceptado'}
          <img
            src="/images/revista/revisor-v-color.svg"
            title={dict['aceptadoParaPublicacion']}
            alt="Revision Icon" />
        {:else if articulo.revisadoDocumento2 === 'CambiosMenores'}
          <img
            src="/images/revista/revisor-v-minor-color.svg"
            title={dict['aceptadoConCambiosMenores']}
            alt="Revision Icon" />
        {:else if articulo.revisadoDocumento2 === 'CambiosMayores'}
          <img
            src="/images/revista/revisor-v-major-color.svg"
            title={dict['aceptadoConCambiosMayores']}
            alt="Revision Icon" />
        {:else if articulo.revisadoDocumento2 === 'Rechazado'}
          <img
            src="/images/revista/revisor-x-color.svg"
            title={dict['rechazado']}
            alt="Revision Icon" />
        {:else}
          <img
            src="/images/revista/clock.svg"
            title={dict['esperandoRevision']}
            alt="Revision Icon" />
        {/if}
      </td>
    </tr>
  {/if}
</table>
